import slider from '../../assets/hero-image.jpg';
import './hero-section.css';
import { closeSubMenu } from '../../utils/js/close-menu';

const HeroSection = () => {
  return (
    <div className="hero-section" onClick={closeSubMenu}>
      <div className="container grid grid--2-cols">
        <div className="hero-image-box">
          <img src={slider} alt="hero-image" className="hero-image" />
        </div>
        <div className="hero-text-box">
          <h2 className="heading-primary">
            Crack your goal with India’s top educators
          </h2>
          <p className="header-description margin-bottom-xl">
            Lorem ipsum dolor sit amet, consectetur adipisicing elit. Libero, et
            necessitatibus exercitationem cum.
          </p>
          <a href="#cta-section" className="btn">
            Join for free
          </a>
        </div>
      </div>
    </div>
  );
};

export default HeroSection;
